export default "__VITE_ASSET__620ec4b8__"